import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

const DESCRIPTION_KEYS = ['noKnowledge', 'basic', 'good', 'advanced'] as const;

const getLevelColor = (key: string): string => {
  const colors: Record<string, string> = {
    advanced: '#f16e00',
    basic: '#f16e00',
    good: '#f16e00',
    noKnowledge: '#666',
  };
  return colors[key] ?? '#f16e00';
};

const SkillsIntroText: React.FC = () => {
  const { t } = useTranslationWithPrefix('skillsAssessmentCollectedPage');

  return (
    <div className="mb-6 md:mb-8 w-full">
      <p className="text-base md:text-lg mb-5 md:mb-6 leading-relaxed" style={{ color: '#333' }}>
        {t('introText')}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 rounded-lg">
        {DESCRIPTION_KEYS.map((key, index) => (
          <div
            className="flex items-start gap-3 p-3"
            key={key}
          >
            <div
              className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-bold"
              style={{ backgroundColor: getLevelColor(key) }}
            >
              {index + 1}
            </div>
            <div className="flex-1 min-w-0">
              <span
                className="font-bold block mb-1 text-sm md:text-base"
                style={{ color: getLevelColor(key) }}
              >
                {t(`standardRatingLabels.${key}`)}
              </span>
              <span className="text-xs md:text-sm leading-snug block" style={{ color: '#666' }}>
                {t(`standardRatingDescriptions.${key}`)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillsIntroText;
